import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'

export const proposalStep2PriceTypeEnum = ['agreed', 'recommended'] as const
export const proposalStep2PriceTypeEnumSchema = z.enum(proposalStep2PriceTypeEnum, { errorMap })
export type ProposalStep2PriceTypeEnum = z.output<typeof proposalStep2PriceTypeEnumSchema>

export const ProposalStep2ServiceDtoSchema = z.object({
   serviceId: z.string(),
   serviceDefinition: z.string(),
   serviceHowItWorks: z.string(),
   serviceName: z.string(),
   servicePriceType: proposalStep2PriceTypeEnumSchema,
})

export type ProposalStep2ServiceDto = z.output<typeof ProposalStep2ServiceDtoSchema>
export const ProposalStep2DtoSchema = z.array(ProposalStep2ServiceDtoSchema)
export type ProposalStep2Dto = z.output<typeof ProposalStep2DtoSchema>
